export default __webpack_public_path__ + "static/media/IMG_5062.96f718be.png";